import { useEffect, useState } from 'react';
import client from '../shopify/client';
import { GET_PRODUCTS } from '../shopify/queries';
import ProductCard from '../components/ProductCard';
import './Shop.css';

export default function Shop() {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        client
            .request(GET_PRODUCTS, { variables: { first: 24 } })
            .then(({ data }) => {
                setProducts(data.products.edges.map((e) => e.node));
            })
            .catch(() => setError('Produkte konnten nicht geladen werden.'))
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return (
            <div className="shop-loading">
                <span className="shop-spinner" />
            </div>
        );
    }

    if (error) {
        return <p className="shop-error">{error}</p>;
    }

    if (products.length === 0) {
        return <p className="shop-empty">Noch keine Produkte verfügbar.</p>;
    }

    return (
        <main className="shop-page">
            <h1 className="shop-heading">Shop</h1>
            <div className="product-grid">
                {products.map((product) => (
                    <ProductCard key={product.id} product={product} />
                ))}
            </div>
        </main>
    );
}
